import { deploymentStrategy } from '@emma/core/consts';
import { z } from 'zod';

const NAME_ERROR =
  'Name must be 5-100 characters and contain only lowercase letters, numbers, dots, or underscores';

export const fleetNameSchema = z.string().regex(/^[a-z0-9._]{5,100}$/, NAME_ERROR);

export const deploymentStrategySchema = z.enum(deploymentStrategy);
